var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gr-border container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h2',{staticClass:"upper"},[_c('strong',[_vm._v("Thank you for your interest in our STEM Career Day Program.")])]),_c('p',{staticClass:"upper"},[_vm._v("Your questions and/or comments have been sent.")])])])])
}]

export { render, staticRenderFns }